import { render, staticRenderFns } from "./Heroes.vue?vue&type=template&id=73471a78&"
import script from "./Heroes.vue?vue&type=script&lang=js&"
export * from "./Heroes.vue?vue&type=script&lang=js&"
import style0 from "./Heroes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports